import React from "react";
import { X, User, Heart, Ban } from "lucide-react";
import { calcAge } from "../../utils/helpers";
import { useAppContext } from "../../context/AppContext";

export default function PetProfileModal({
  selectedChatUser,
  setSelectedChatUser,
  selectedChatPetDetails,
  allUsers,
  followingList,
  handleToggleFollow,
  handleStartDM,
  handleBlockUser,
}: any) {
  const { lang, t, user } = useAppContext();

  return (
    <div
      className="fixed inset-0 bg-black/60 z-[500] flex items-center justify-center backdrop-blur-sm animate-fade-in p-4"
      onClick={() => setSelectedChatUser(null)}
    >
      <div
        className="bg-[var(--bg-card)] rounded-[2rem] p-6 w-full max-w-xs shadow-2xl flex flex-col items-center relative animate-slide-up border border-[var(--border-color)]"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={() => setSelectedChatUser(null)}
          className="absolute top-4 right-4 p-1.5 bg-[var(--bg-soft)] rounded-full text-[var(--text-muted)] border border-[var(--border-color)]"
        >
          <X size={18} />
        </button>
        <div className="w-24 h-24 rounded-full bg-[var(--accent-soft)] mb-4 overflow-hidden border-4 border-[var(--bg-card)] shadow-lg flex items-center justify-center text-[#a073e7] font-bold text-3xl">
          {selectedChatPetDetails?.photo || selectedChatUser.photo ? (
            <img
              src={selectedChatPetDetails?.photo || selectedChatUser.photo}
              className="w-full h-full object-cover"
            />
          ) : (
            <User size={40} />
          )}
        </div>
        <h3 className="font-black text-2xl text-[var(--text-main)] mb-1 text-center">
          {selectedChatPetDetails?.name || selectedChatUser.name}
        </h3>
        <p className="text-[11px] font-black text-[#a073e7] bg-[var(--accent-soft)] px-3 py-1 rounded-full mb-3 uppercase tracking-wide">
          {selectedChatPetDetails?.breed || selectedChatUser.breed || t.notSpec}
        </p>

        {selectedChatPetDetails?.isHeatActive && (
          <div className="inline-flex items-center gap-1.5 px-3 py-1 mb-3 mt-[-4px] bg-[#ef4444] text-white text-xs font-bold rounded-full animate-pulse">
            <Heart size={12} fill="currentColor" />{" "}
            {lang === "uk" ? "Тічка зараз" : "In Heat"}
          </div>
        )}

        <div className="flex gap-4 w-full justify-center mt-2 mb-4 border-t border-[var(--border-color)] pt-4">
          <div className="flex flex-col items-center flex-1">
            <span className="font-black text-lg text-[var(--text-main)]">
              {
                allUsers.filter((u: any) =>
                  u.following?.includes(selectedChatUser.id)
                ).length
              }
            </span>
            <span className="text-[10px] uppercase font-bold text-[var(--text-muted)]">
              {lang === "uk" ? "Підписники" : "Followers"}
            </span>
          </div>
          <div className="w-px bg-[var(--border-color)]"></div>
          <div className="flex flex-col items-center flex-1">
            <span className="font-black text-lg text-[var(--text-main)]">
              {allUsers.find((u: any) => u.id === selectedChatUser.id)
                ?.following?.length || 0}
            </span>
            <span className="text-[10px] uppercase font-bold text-[var(--text-muted)]">
              {lang === "uk" ? "Підписки" : "Following"}
            </span>
          </div>
        </div>
        <div className="w-full bg-[var(--bg-soft)] rounded-2xl p-4 flex justify-around border border-[var(--border-color)]">
          <div className="flex flex-col items-center">
            <span className="text-[10px] uppercase font-bold text-[var(--text-muted)] mb-1">
              {t.gender}
            </span>
            <span className="font-bold text-sm text-[var(--text-main)]">
              {selectedChatPetDetails?.gender || selectedChatUser.gender || "—"}
            </span>
          </div>
          <div className="w-px bg-[var(--border-color)] mx-2"></div>
          <div className="flex flex-col items-center">
            <span className="text-[10px] uppercase font-bold text-[var(--text-muted)] mb-1">
              {t.age}
            </span>
            <span className="font-bold text-sm text-[var(--text-main)]">
              {calcAge(
                selectedChatPetDetails?.dob || selectedChatUser.dob,
                t
              ) || "—"}
            </span>
          </div>
        </div>

        {selectedChatUser.id && selectedChatUser.id !== user?.uid && (
          <div className="w-full flex flex-col gap-2 mt-6">
            <div className="flex gap-2">
              <button
                onClick={() => handleToggleFollow(selectedChatUser.id)}
                className={`flex-1 py-3 font-bold rounded-xl shadow-md text-sm ${
                  followingList.includes(selectedChatUser.id)
                    ? "bg-[var(--bg-soft)] text-[var(--text-main)] border border-[var(--border-color)]"
                    : "bg-[var(--inverted-btn)] text-[var(--inverted-text)]"
                }`}
              >
                {followingList.includes(selectedChatUser.id)
                  ? lang === "uk"
                    ? "Відписатися"
                    : "Unfollow"
                  : lang === "uk"
                  ? "Підписатися"
                  : "Follow"}
              </button>
              <button
                onClick={() => handleStartDM(selectedChatUser)}
                className="flex-1 py-3 bg-[#a073e7] text-white font-bold rounded-xl shadow-md text-sm"
              >
                {lang === "uk" ? "Написати" : "Message"}
              </button>
            </div>
            <button
              onClick={() => handleBlockUser(selectedChatUser.id)}
              className="w-full py-3 bg-[var(--red-soft)] text-[var(--red-text)] font-bold rounded-xl text-sm flex justify-center items-center gap-2 mt-1"
            >
              <Ban size={16} />{" "}
              {lang === "uk" ? "Заблокувати користувача" : "Block User"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
